const COORDINATES = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'A', 'B', 'C', 'D', 'E', 'F']

export default class Tiles extends Phaser.Group {
  constructor (game, parent, memory, tileMap, tileLayer, levelIndex) {
    super(game, parent, 'tilesGroup')

    this.memory = memory
    this.tileMap = tileMap
    this.tileLayer = tileLayer
    this.levelIndex = levelIndex

    this.overlayText = this.setupOverlayText()
    this.updateOverlayText()

    this.setupOriginalTiles()
    this.setupDefaultTileIndices()

    if (this.levelIndex > 1) {
      this.alpha = 0.2
    } else {
      this.alpha = 0
    }

    for (let i = 0; i < 12; i++) {
      for (let j = 0; j < 12; j++) {
        const tile = tileMap.getTile(i, j, tileLayer)
        memory.set(j, i, tile.properties.value)
      }
    }

    memory.watchAll((y, x, value) => {
      if (y < 12 && x < 12) {
        this.onTileChanged(y, x, value)
      }
    })
  }

  setupOriginalTiles () {
    this.originalTiles = []

    for (let i = 0; i < 12; i++) {
      this.originalTiles.push([])
      for (let j = 0; j < 12; j++) {
        const tile = this.tileMap.getTile(i, j, this.tileLayer)
        this.originalTiles[i][j] = {
          index: tile.index - 1,
          value: tile.properties.value
        }
      }
    }
  }

  setupOverlayText () {
    const overlayText = []

    for (let i = 0; i < 12; i++) {
      overlayText.push([])

      for (let j = 0; j < 12; j++) {
        const text = this.game.add.bitmapText(3 + i * 16, 4 + j * 16, 'monospace', '', 9, this)
        overlayText[i][j] = text
      }
    }

    return overlayText
  }

  setupDefaultTileIndices () {
    this.defaultTileIndices = {}

    const tilesetIndex = this.tileMap.getTilesetIndex('tiles')
    const tileset = this.tileMap.tilesets[tilesetIndex]

    const valueFirsts = {}

    for (const tileIndex in tileset.tileProperties) {
      const tileProperties = tileset.tileProperties[tileIndex]
      if (typeof tileProperties.value !== 'undefined') {
        const value = tileProperties.value
        if (typeof valueFirsts[value] === 'undefined') {
          valueFirsts[value] = parseInt(tileIndex)
        }

        if (typeof tileProperties.default !== 'undefined') {
          this.defaultTileIndices[value] = parseInt(tileIndex)
        }
      }
    }

    for (const value in valueFirsts) {
      if (typeof this.defaultTileIndices[value] === 'undefined') {
        this.defaultTileIndices[value] = valueFirsts[value]
      }
    }
  }

  onTileChanged (y, x, value) {
    const tile = this.tileMap.getTile(x, y, this.tileLayer)

    let newTileIndex
    if (value === this.originalTiles[x][y].value) {
      newTileIndex = this.originalTiles[x][y].index
    } else {
      if (typeof this.defaultTileIndices[value] !== 'undefined') {
        newTileIndex = this.defaultTileIndices[value]
      } else {
        newTileIndex = 4
      }
    }

    this.tileMap.replace(tile.index, newTileIndex + 1, x, y, 1, 1, this.tileLayer)

    const tilesetIndex = this.tileMap.getTilesetIndex('tiles')
    const tileset = this.tileMap.tilesets[tilesetIndex]
    tile.properties = tileset.tileProperties[newTileIndex]
    tile.properties.value = value

    this.updateOverlayText()
  }

  updateOverlayText () {
    for (let i in this.overlayText) {
      for (let j in this.overlayText[i]) {
        const tile = this.tileMap.getTile(i, j)
        const value = toHex(tile.properties.value)
        const overlay = this.overlayText[i][j]

        if (overlay.text !== `${value}`) {
          const currentAlpha = overlay.alpha

          const fadeOut = this.game.add.tween(overlay)
          fadeOut.to({alpha: 0}, 50, Phaser.Easing.Linear.None, false)
          fadeOut.onComplete.add(() => { this.overlayText[i][j].text = `${value}` })

          const fadeIn = this.game.add.tween(overlay)
          fadeIn.to({alpha: currentAlpha}, 50, Phaser.Easing.Linear.None, false)
          fadeOut.chain(fadeIn)

          fadeOut.start()
        }
      }
    }
  }

  flashOverlayText () {
  }

  setHighlight (highlight) {
    if (this.levelIndex > 1) {
      const tween = this.game.add.tween(this)
      tween.to({
        alpha: highlight ? 1.0 : 0.2
      }, 200, Phaser.Easing.Linear.None, true)
    }
  }
}

function toHex (value) {
  const high = Math.floor(value / 16)
  const low = value % 16

  return `${COORDINATES[high]}${COORDINATES[low]}`
}
